import React, { lazy, Suspense } from "react";

//import DefaultLoader from "../utilities/loaders/DefaultLoader";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const DailyRateManagementContent = lazy(
  () => import("./DailyRateManagementContent"),
);

const PurposeManagement = () => {
  return (
    <Suspense fallback={<DefaultLoader />}>
      <DailyRateManagementContent />
    </Suspense>
  );
};

export default DailyRateManagementContent;
